// extracted by mini-css-extract-plugin
module.exports = {"received":"paymentTransactionStatusColumn_received__468V5","refunded":"paymentTransactionStatusColumn_refunded__ND4s_","removed":"paymentTransactionStatusColumn_removed__2roV2"};